import * as React from 'react';
import styled from 'styled-components';
import { __ } from 'react-i18n';
import { rem } from 'polished';
import { getImagePath, getImagePathNew } from '../../utilities';

interface Props {
  image: string;
  alt: string;
  width: number;
  height: number;
  noSize?: boolean;
  circle?: boolean;
  cover?: boolean;
  lazy?: boolean;
  className?: string;
  hoverable?: boolean;
}

export function WebP({
  image,
  alt,
  width,
  height,
  noSize,
  circle,
  cover,
  lazy,
  className = '',
  hoverable,
}: Props) {
  return (
    <picture>
      <source
        type="image/webp"
        srcSet={
          image !== ''
            ? getImagePathNew(image, { width, height }, noSize, true, cover)
            : 'https://via.placeholder.com/290x160.png'
        }
      />
      <source
        type="image/jpeg"
        srcSet={
          image !== ''
            ? getImagePathNew(image, { width, height }, noSize, false, cover)
            : 'https://via.placeholder.com/290x160.png'
        }
      />
      <Image
        className={className}
        hoverable={hoverable}
        loading={lazy ? 'lazy' : undefined}
        circle={circle}
        alt={alt}
        src={
          image !== ''
            ? getImagePathNew(image, { width, height }, noSize, false, cover)
            : 'https://via.placeholder.com/290x160.png'
        }
      />
    </picture>
  );
}

const Image = styled.img<{ circle?: boolean; hoverable?: boolean }>`
  /* width: ${rem(280)};
  height: ${rem(280)}; */
  border-radius: ${({ circle }) => (circle ? '50%' : 'initial')};
  max-width: 100%;
  height: auto;
  vertical-align: middle;
  text-indent: 100%;
  white-space: nowrap;
  overflow: hidden;

  &:hover {
    transform: ${({ hoverable }) => (hoverable ? 'scale(0.9)' : 'initial')}; ;
  }

  ${({ theme }) => theme.mediab.m580`
    width: 100%;
    height: auto;
  `}
`;
